import React, { useState, useMemo, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Card, Accordion, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
//import "./AssetView.scss";
import TutorialPopup from "../../help/TutorialPopup";
import * as HelpContent from "../../../utils/HelpContent";
import { CHANGE_PAIR, CHANGE_RENT_PAIR } from "../../../actions/create-bot-type";
import { getBalance, getPairBalance } from "../../../actions/bot-action";
import SymbolSearchBox from "../../bots/new-bot/modules/SymbolSearchBox";

const AssetViewRent = (props) => {
  const { rentBot,getBalance ,getPairBalance,selectedExchange,t,editing} = props;
  const [baseCoin, setBaseCoin] = useState(rentBot.assetType??"us_equity");
  const [changeBase, setClickChangeBase] = useState(false);
  const usEquity = useSelector((state) => state.bots.usEquity);
  const forex = useSelector((state) => state.bots.forex);
  const indice = useSelector((state) => state.bots.indice);
  const metal = useSelector((state) => state.bots.metal);
  const dispatch = useDispatch();
  //const selectedExchange = rentBot.exchange;
  const pairList = useMemo(() => {
    return baseCoin === "us_equity"
      ? usEquity
      : baseCoin === "forex"
      ? forex
      : baseCoin === "indice"?indice:metal;
  }, [baseCoin]);

  const pairItems =
    (pairList &&
      pairList.map((item) => ({
        value: item.id,
        label: `${item.pair.from}/${item.pair.to}`,
        from: item.pair.from,
        to: item.pair.to,
      }))) ||
    [];
  const pair = rentBot.pair;
  const selectedPair = {
    value: rentBot.exchangePairId,
    label: `${pair.from}/${pair.to}`,
    from: pair.from,
    to: pair.to,
  };

  const handleSelectPair = (item) => {
    getBalance(selectedExchange.id)
    const newPair = pairList.find((el) => item.value == el.id) || {};
    getPairBalance(selectedExchange.id,newPair.pair_id,baseCoin);
    dispatch({
      type: CHANGE_RENT_PAIR,
      payload: newPair,
    });
  };
  const clickChangeBase = (strategy) => {
    setClickChangeBase(true)
  };
  useEffect(()=>{
    if(editing)
    {
      if(changeBase){
        dispatch({
          type: CHANGE_PAIR,
          payload: pairList[0],
        });
      }
    }
    else{
      if(pairList && pairList[0]){
        dispatch({
          type: CHANGE_RENT_PAIR,
          payload: pairList[0],
        });
      }
    }
  },[baseCoin])


  return (
    <>
      <Card className="asset">
        <Accordion.Toggle as={Card.Header} eventKey="0">
          1. Asset
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <Card.Body>
            <Form.Group>
              <Form.Label>
                Brokerage <TutorialPopup content={t(HelpContent.exchange)} />
              </Form.Label>
              <div className="mt-1 mb-3">
                <img
                  src={selectedExchange.image}
                  width={20}
                  height={20}
                  style={{ marginRight: 10 }}
                />
                <span style={{ fontWeight: "bold", fontSize: 16 }}>
                  {selectedExchange.name}
                </span>
              </div>
            </Form.Group>
            <Form.Group style={{ marginTop: 20 }}>
              <Form.Label className="bot-asset-tour">
                {t("Markets")} 
              </Form.Label>
              <Row>
              <Col  xs={12} lg={12} className="">
                  <Form.Group
                    as={Row}
                    className="mt-2 ml-1"
                    onChange={(e) => setBaseCoin(e.target.value)}
                    onClick={(e) => clickChangeBase(e.target.value)}
                  >
                    <Form.Check
                      type="radio"
                      label="US Equities"
                      name="filter"
                      value="us_equity"
                      className="mr-2"
                      defaultChecked={baseCoin=="us_equity"}
                    />
                    <Form.Check
                      type="radio"
                      label="Forex"
                      name="filter"
                      value="forex"
                      className="mr-2"
                      defaultChecked={baseCoin=="forex"}
                    />
                    <Form.Check
                      type="radio"
                      label="Indices"
                      name="filter"
                      value="indice"
                      className="mr-2"
                      defaultChecked={baseCoin=="indice"}
                    />
                    <Form.Check
                      type="radio"
                      label="Metals"
                      name="filter"
                      value="metal"
                      className="mr-2"
                      defaultChecked={baseCoin=="metal"}
                    />
                    
                  </Form.Group>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group style={{ marginTop: 20 }}>
              <Form.Label className="bot-asset-tour">
                {t("Symbol to trade")} <TutorialPopup content={t("tradingpair-help")} />
              </Form.Label>
              <Row>
                <Col style={{ maxWidth: "70%" }}>
                   {/* <SymbolSearchBox selectedExchange={selectedExchange} selected={handleSelectPair} selectedPair={selectedPair}></SymbolSearchBox> */}
                   <Select
                    value={selectedPair}
                    options={pairItems}
                    onChange={handleSelectPair}
                    className='react-select-container third-step'
                    classNamePrefix='react-select'
                  />
                </Col>
               
                
              </Row>
            </Form.Group>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export default connect(null,{getBalance,getPairBalance})(AssetViewRent);
